import { ApiHost } from "./api-host";

// 与网络请求相关的基础参数配置
export const commonParams = {
    PAAS_URL: ApiHost.get(),//web端api请求URL
    PAAS_CONFIG: `/paas/${ApiHost.getDomain()}`,
    CDN_URL: process.env.DOMAIN_CDN_API_URL,
    CREDAMO_CONFIG: '/credamo/config/',
    CDN_LOGO: `${process.env.DOMAIN_CDN_API_URL}/credamo/img/logo.jpg`,
    CDN_IMG_PREFIX: `${process.env.DOMAIN_CDN_API_URL}/credamo/img`,
    CDN_IMG_PAAS:`${process.env.DOMAIN_CDN_API_URL}/paas/img`,
    CDN_HOME_IMG: `${process.env.DOMAIN_CDN_API_URL}/credamo/home/img`,
    CDN_HOME_FILE: `${process.env.DOMAIN_CDN_API_URL}/credamo/home/file`,
    CDN_HOME_VIDEO: `${process.env.DOMAIN_CDN_API_URL}/credamo/home/video`,
    CREDAMO_HOST: 'https://www.credamo.com/#/',
    CREDAMO_HELP_DOMAIN_NAME: process.env.CREDAMO_HELP,
    CREDAMO_HELP: `${process.env.DOMAIN_WEB_URL}/#`,
    ONLINE_SERVICE: 'https://work.weixin.qq.com/kfid/kfc37e28f3570e63cd0'
}



// WEBPACK FOOTER //
// ./src/config/common.js